import { z, isoZ } from 'my-zod'
import { productLineOptions } from '../../internal/product-lines'

export const performanceByMonthModel = z.object({
  month: isoZ.yearMonth(),
  outfitter: z.string(),
  operatorId: z.string(),
  region: z.string(),
  programName: z.string().nullable(),
  productLine: z.enum(productLineOptions),
  numberOfCheckOuts: z.number().nullable(),
  rentalDays: z.number().nullable(),
  fleetUtilization: z.string().nullable(),
  totalRiderCount: z.number().nullable(),
  netPromoterScore: z.string().nullable(),
  npsResponseCount: z.number().nullable(),
  totalRawRiderCount: z.number().nullable()
})

export type performanceByMonthModel = z.infer<typeof performanceByMonthModel>
